































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  ReimbursementFailureDetailModel,
  reimbursementTypeMap,
  accountSubStatusMap,
} from "@/admin/types";
import {
  accountStatusMap,
  bankCustodianMap
} from "@/shared/types";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useReimbursementFailureStore } from "@/admin/store/reimbursementFailure";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class AdminUtilityReimbursementFailureDetail extends Vue {
  formatCurrency = formatCurrency;
  formatDateString = formatDateString;
  accountStatusMap = accountStatusMap;
  accountSubStatusMap = accountSubStatusMap;
  reimbursementTypeMap = reimbursementTypeMap;
  bankCustodianMap = bankCustodianMap;

  notifierStore = useNotifierStore();
  reimbursementFailureStore = useReimbursementFailureStore();

  @Prop() reimbursementFailureDetail: ReimbursementFailureDetailModel;

  isArchived = false;
  isSaving = false;

  @Watch("reimbursementFailureDetail", { deep: true })
  onDetailChanged (detail: ReimbursementFailureDetailModel) {
    this.isArchived = detail.isArchived;
  }
  onCancelClick () {
    this.$router.go(-1);
  }
  onResolveClick () {
    this.reimbursementFailureStore.resolveById(this.reimbursementFailureDetail.reimbursementId).then(v => {
      this.notifierStore.setSuccess("Reimbursement Failure item has been archived.");
    });
  }
  get isLoaded () {
    return this.reimbursementFailureStore.isDetailLoaded;
  }
}
